//----------------------------------------------
//  convert F to C
function FtoC(form) {
	form.C.value = roundDec(100/(212-32) * (form.F.value - 32), 2);
}


//----------------------------------------------
//  convert C to F
function CtoF(form) {
	form.F.value = roundDec((212-32)/100 * form.C.value + 32, 2);
}

//-------------------------------------------------------
// CFL Systems
// Rounds a value to a specified number of decimal places and returns it.
if (typeof roundDec !== 'function') {
  function roundDec(val, dig) {

	// If no value is specified for number of significant digits
	// then set a predetermined value
	if (dig == "" || dig == undefined || dig == null)
		dig = 10

	var div = Math.pow(10, dig)
	return (Math.round(val * div) / div)
  }
}